import Table from "@/components/Table";
import { getStickyColumnClasses } from "@/lib/styleHelpers";
import type { Path } from "@/router";
import type { Section } from "@/types";

type Props = {
  sections: Section[];
};

export default function SectionsCatalogTable({ sections }: Props) {
  return (
    <Table
      loading={false}
      data={sections}
      getRowLink={(row) => ({
        to: `/sections/${row.original.id}` as Path
      })}
      columns={[
        {
          accessorKey: "name",
          header: "Name",
          enableSorting: false,
          meta: {
            className: getStickyColumnClasses(sections.length > 0)
          }
        }
      ]}
    />
  );
}
